export function isPlacaLinkedSon(item?: {
  description?: string | null
  typeOfSon?: string | null
} | null): boolean {
  if (!item) return false
  const desc = String(item.description ?? '').toLowerCase()
  const type = String(item.typeOfSon ?? '').toLowerCase()
  return type === 'placa' || desc === 'placa' || desc.includes('placa')
}

export function findSiblingEncimera<
  T extends {
    type?: string
    description?: string
    typeOfSon?: string
    firstParentID?: string
  },
>(items: Map<string, T>, parentId?: string | null): T | null {
  if (!parentId) return null
  let found: T | null = null
  items.forEach((item) => {
    if (item.type !== 'linkedSon') return
    if (item.firstParentID !== parentId) return
    const desc = String(item.description ?? '').toLowerCase()
    const type = String(item.typeOfSon ?? '')
    if (desc.includes('encimera') || type === 'Encimera') found = item
  })
  return found
}
